import * as React from 'react'
import Table from '@mui/material/Table'
import TableBody from '@mui/material/TableBody'
import TableCell from '@mui/material/TableCell'
import TableContainer from '@mui/material/TableContainer'
import TableHead from '@mui/material/TableHead'
import TableRow from '@mui/material/TableRow'
import Paper from '@mui/material/Paper'
import PackageProviderRow from "./PackageProviderRow"
import {IconButton} from "@mui/material"
import AddIcon from '@mui/icons-material/Add'
import Grid from "@mui/material/Grid"

const PackageProviderTable = ({formValues, setFormValues}) => {
  // Service type choices matching backend CATEGORY_SERVICE_TYPE_CHOICES
  const serviceTypeChoices = [
    {value: 10, label: 'Likes'},
    {value: 20, label: 'Followers'},
    {value: 50, label: 'Views'},
    {value: 30, label: 'Random Comments'},
    {value: 40, label: 'Custom Comments'},
    {value: 90, label: 'Blue-Tick Comments'},
    {value: 100, label: 'Shares'},
  ]

  const addRow = () => {
    formValues.package_providers.push({
      uid: null,
      service_type: null,
      quantity: '',
      display_quantity: '',
    })
    setFormValues({...formValues, package_providers: formValues.package_providers})
  }

  const removeRow = (index) => {
    formValues.package_providers.splice(index, 1)
    setFormValues({...formValues, package_providers: formValues.package_providers})
  }

  return (
    <TableContainer component={Paper}>
      <Table sx={{minWidth: 500}}>
        <TableHead>
          <TableRow>
            <TableCell align="center" width="50%">SERVICE TYPE</TableCell>
            <TableCell align="center" width="20%">QUANTITY</TableCell>
            <TableCell align="center" width="20%">DISPLAY QUANTITY</TableCell>
            <TableCell align="center" width="10%">ACTIONS</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {formValues.package_providers.map((package_provider, index) => {
            return (
              <PackageProviderRow
                key={index}
                {...{serviceTypeChoices, index, formValues, setFormValues, removeRow}}
              />
            )
          })}
        </TableBody>
      </Table>

      <Grid container>
        <Grid item xs={12} sm={12} md={12} sx={{textAlign: 'center', margin: '10px'}}>
          <IconButton
            size="large"
            color={'primary'}
            onClick={addRow}
            variant={'outlined'}
          >
            <AddIcon/>
          </IconButton>
        </Grid>
      </Grid>
    </TableContainer>
  )
}

export default PackageProviderTable
